<template>
  <div class="flex items-center gap-3 py-4 w-full cursor-pointer border-b border-grey-50 last:border-b-0 text-secondary-txt">
    <GSelectAvatar height="32" width="32" :country-code="flagCountryCode" />
    <span class="flex-1 min-w-0 text-3 font-semibold">
      {{ currencyName[currencyCode] ?? currencyCode }}
    </span>
    <GIconFont name="solid chevron-right" />
  </div>
</template>

<script lang="ts" setup>
import GSelectAvatar from '@/components/GSelectNext/components/GSelectAvatar.vue';
import { GIconFont } from '@flash-global66/g-icon-font';
import { currencyName } from '@/shared/common/constants/currencyName.constant';

defineProps<{
  currencyCode: string;
  flagCountryCode: string;
}>();
</script>
